/**
 * Página de Login do Vendedor
 */

import React, { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { Visibility, VisibilityOff, Login as LoginIcon } from '@mui/icons-material';
import { useAuth } from '@hooks';
import { LoginVendedorRequest } from '@types';

export const LoginVendedor: React.FC = () => {
  const { isLoading, error, login, clearError } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState<LoginVendedorRequest>({
    usuario: '',
    senha: '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    try {
      await login(credentials);
      // Redirecionamento automático pelo hook useAuth
    } catch (err) {
      // Erro já está no estado
    }
  };

  const handleChange = (field: keyof LoginVendedorRequest) => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCredentials({
      ...credentials,
      [field]: e.target.value,
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#4db6ac',
        backgroundImage: 'url(/images/bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        px: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          borderRadius: 3,
        }}
      >
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Box
            component="img"
            src="/images/logo.png"
            alt="Logo"
            sx={{
              width: '100%',
              maxWidth: 200,
              height: 'auto',
              mb: 2,
              display: 'block',
              margin: '0 auto',
            }}
          />
          
          {
            /* NAO REMOVER!
              <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
                Pedidos Avulsos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sistema de Gestão de Vendas
              </Typography>
            */
          }
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email / Usuário"
            type="email"
            value={credentials.usuario}
            onChange={handleChange('usuario')}
            margin="normal"
            required
            autoComplete="email"
            autoFocus
            disabled={isLoading}
          />

          <TextField
            fullWidth
            label="Senha"
            type={showPassword ? 'text' : 'password'}
            value={credentials.senha}
            onChange={handleChange('senha')}
            margin="normal"
            required
            autoComplete="current-password"
            disabled={isLoading}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            size="large"
            disabled={isLoading || !credentials.usuario || !credentials.senha}
            startIcon={isLoading ? <CircularProgress size={20} /> : <LoginIcon />}
            sx={{ mt: 3, mb: 2 }}
          >
            {isLoading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            Versão 26.03.2026
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginVendedor;